<template>
    <div v-if="showVerticalMenu" id="vMenu">
        <b-link
            v-b-toggle.mine
            class="list-group-item item"
            :class="activeMine"
        >
            MES TO DO&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>
        <b-collapse id="mine" :visible="openMine">
            <b-list-group-item
                :href="menuRoutes['ownTasks']"
                class="item sub-item"
                :active="pageName === 'ownTasks'"
                data-parent="#vMenu"
                @click="setPageName('ownTasks')"
            >
                <i class="fa-fw fal fa-tasks menu-icon"></i>
                To do
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        :values="counters.ownTasks"
                    ></counter>
                </div>
            </b-list-group-item>

            <b-list-group-item
                :href="menuRoutes['ownDelegatedTasks']"
                class="item sub-item"
                :active="pageName === 'ownDelegatedTasks'"
                data-parent="#vMenu"
                @click="setPageName('ownDelegatedTasks')"
            >
                <i class="fa-fw fal fa-tasks menu-icon"></i>
                To be done
                <div class="float-right">
                    <counter
                        v-if="showCounters"
                        :values="counters.delegatedTasks"
                    ></counter>
                </div>
            </b-list-group-item>

            <div v-if="pageName !== 'newTask'" class="text-center p-3">
                <b-button
                    :href="menuRoutes['newTask']"
                    variant="light"
                    class="btn-block"
                    @click="setPageName('newTask')"
                >
                    <i class="fas fa-fw fa-plus"></i>
                    Ajouter une tâche
                </b-button>
            </div>
        </b-collapse>
        <template v-if="viewAllTodos">
            <b-link
                v-b-toggle.others
                class="list-group-item item"
                :class="activeOthers"
            >
                AUTRES TO DO&nbsp;<i class="fa fa-caret-down"></i>
            </b-link>
            <b-collapse id="others" :visible="openOthers">
                <b-list-group-item
                    :href="menuRoutes['othersTasks']"
                    class="item sub-item"
                    :active="pageName === 'othersTasks'"
                    data-parent="#vMenu"
                    @click="setPageName('othersTasks')"
                >
                    <i class="fa-fw fal fa-tasks menu-icon"></i>
                    To do
                </b-list-group-item>

                <b-list-group-item
                    :href="menuRoutes['othersDelegatedTasks']"
                    class="item sub-item"
                    :active="pageName === 'othersDelegatedTasks'"
                    data-parent="#vMenu"
                    @click="setPageName('othersDelegatedTasks')"
                >
                    <i class="fa-fw fal fa-tasks menu-icon"></i>
                    To be done
                </b-list-group-item>
            </b-collapse>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import counter from '../../activity/components/common/counter'

export default {
    name: 'TodoVerticalMenu',

    components: {
        counter,
    },

    props: {
        page: '',
    },

    data() {
        return {
            openMine: false,
            activeMine: '',
            openOthers: false,
            activeOthers: '',
            openBilling: false,
            activeBilling: '',
        }
    },

    async created() {
        await this.$store.dispatch('todoVM/getRoutes')
        await this.$store.dispatch('todoVM/refreshCounters')
        this.$store.commit('todoVM/SHOW_VERTICAL_MENU')
        this.handleMineMenu()
        this.handleOthersMenu()
        this.handleBillingMenu()
    },

    mounted() {
        this.$store.commit('todoVM/SET_IS_ADMIN', this.menuRoutes.viewAllTodos)
    },

    methods: {
        setPageName(pageName) {
            this.$store.commit('browsing/SET_PAGE_NAME', pageName)
        },
        handleMineMenu() {
            this.openMine = ['ownTasks', 'ownDelegatedTasks'].includes(
                this.page
            )
            this.activeMine = this.openMine ? 'active' : ''
        },
        handleOthersMenu() {
            this.openOthers = ['othersTasks', 'othersDelegatedTasks'].includes(
                this.page
            )
            this.activeOthers = this.openOthers ? 'active' : ''
        },
        handleBillingMenu() {
            this.openBilling = ['billableTasks', 'billedTasks'].includes(
                this.page
            )
            this.activeBilling = this.openBilling ? 'active' : ''
        },
    },

    computed: {
        ...mapState({
            counters: (state) => state.todoVM.counters,
            showCounters: (state) => state.todoVM.showCounters,
            pageName: (state) => state.browsing.pageName,
            showVerticalMenu: (state) => state.todoVM.showVerticalMenu,
            menuRoutes: (state) => state.todoVM.menuRoutes,
            viewAllTodos: (state) => state.todoVM.viewAllTodos,
        }),
    },
}
</script>

<style scoped></style>
